import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'

const ResendVerifyEmail = ({ email, history, resendVerifyEmail, classes }) => {
  const handleEvent = e => {
    e.preventDefault()
    resendVerifyEmail({
      email,
      history,
    })
  }

  return (
    <div>
      <p>Press the button to re-send your verification email</p>
      <Button className={classes.buttonPrimary} fullWidth onClick={handleEvent}>
        Resend Verification Email
      </Button>
    </div>
  )
}

ResendVerifyEmail.propTypes = {
  email: PropTypes.string.isRequired,
  token: PropTypes.string,
  resendVerifyEmail: PropTypes.func.isRequired,
  history: PropTypes.object,
  classes: PropTypes.object,
}

export default ResendVerifyEmail
